export default __webpack_public_path__ + "static/leaves-1dd485e0a03d60375de124ac6d573d11.png";